export default __webpack_public_path__ + "assets/outlined-blue-left-bottom.svg";